import axios from "axios";

export default class AXIOS_API {
  constructor() {

  }

  getRequest(url) {
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          resolve(JSON.parse(response));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  postRequest(url, payload) {

    this.requestdata = JSON.stringify(payload);
    return new Promise((resolve, reject) => {
      axios
        .post(url, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json"
          },
          data: this.requestdata
        }).then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
